import { config, george, observer, React, theme, ui } from "aaa";
import { mockAccounts } from "network/mockResponses";
import { AccountsStore } from "stores/AccountsStore";
import { IAccount } from "types/account";
import { AccessibleDropdown } from "./AccessibleDropdown";
import { Account } from "./Account";

export const ChooseAccountEmbedded = observer((props: {
    store: AccountsStore;
}) => {
    let accounts: IAccount[] = [];
    if (props.store.accounts && props.store.accounts.length > 0) {
        accounts = props.store.accounts;
    } else if (config.DEBUG) {
        accounts = mockAccounts;
    }

    const entries = accounts.map((account, index) =>
        <Account
            key={account.id}
            style={{ padding: theme.MARGIN }}
            account={account}
            checked={props.store.selectedAccount && account.id === props.store.selectedAccount.id}
            onSelectAccount={(selectedAccount) => props.store.selectedAccount = selectedAccount}
            separator={index < accounts.length - 1}
        />
    );

    return (
        <div>
            {!props.store.isLoading && entries}
            <george.LoadingIndicator isLoading={props.store.isLoading} height={50} />
        </div>
    );
});

export const ChooseAccount = observer((props: {
    title?: string,
    store: AccountsStore,
    infoSubtitle?: string,
}) => {
    return (
        <george.Card>
            <george.CardSectionTitle title={props.title || ui.__("shop.accountSelection.title")} style={{ paddingBottom: 0 }} />
            {props.infoSubtitle &&
                <george.SectionSubtitle style={{ padding: theme.MARGIN, margin: 0 }}>
                    {props.infoSubtitle}
                </george.SectionSubtitle>
            }
            <ChooseAccountEmbedded store={props.store} />
        </george.Card>

    );
});


export const ChooseAccountSelect = observer((props: {
    store: AccountsStore;
}) => {
    const accounts: IAccount[] = props.store.accounts ?? [];

    const selectAccount = (selectedAccounts: IAccount[]) => {
        const selectedAccount = selectedAccounts[0];
        if (selectedAccount) {
            props.store.selectAccountById(selectedAccount.id);
        }
    };

    return (
        <AccessibleDropdown
            defaultValues={props.store.selectedAccount ? [props.store.selectedAccount] : []}
            options={accounts}
            single
            valueKey="id"
            onChange={selectAccount}
            optionRenderer={(account, isSelected) =>
                <Account
                    key={account.id}
                    style={{ padding: theme.MARGIN }}
                    account={account}
                    checked={isSelected}
                />

            }
            valueRenderer={(values) => {
                const selectedAccount = values.find(value => value.id === props.store.selectedAccount?.id);
                return selectedAccount ? selectedAccount.description : ui.__("accountSelection.dropdown.label");
            }}
        />
    );
});


// WEBPACK FOOTER //
// ./src/components/common/ChooseAccount.tsx